import React from "react";
import { Modal, Spinner } from "react-bootstrap";

const PageLoader = ({ show }) => {
  return (
    <Modal
      show={show}
      backdrop="static"
      keyboard={false}
      centered
      contentClassName="bg-transparent border-0 shadow-none"
    >
      <div className="d-flex flex-column align-items-center justify-content-center">
        <Spinner animation="border" role="status" variant="light" style={{ width: "3rem", height: "3rem" }}>
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        <span className="mt-3 text-light">Loading...</span>
      </div>
    </Modal>
  );
};

export default PageLoader;
